export default __webpack_public_path__ + "toon-boom-producer.1cb019a0.png";